
const routes = [
  {
    path: '/layout',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '/index', component: () => import('pages/Index.vue') },
      { path: '/users', component: () => import('pages/admin/users/List.vue') },
      { path: '/users/form', component: () => import('pages/admin/users/Form.vue') },
      { path: '/users/view/:id/:rol', component: () => import('pages/admin/users/View.vue') },
      { path: '/users/form/:id', component: () => import('pages/admin/users/Form.vue') },
      { path: '/equipos', component: () => import('pages/admin/equipos/List.vue') },
      { path: '/equipos/form', component: () => import('pages/admin/equipos/Form.vue') },
      { path: '/equipos/form/:id', component: () => import('pages/admin/equipos/Form.vue') },
      { path: '/equipos/view/:id', component: () => import('pages/admin/equipos/View.vue') },
      { path: '/tareas', component: () => import('pages/admin/tareas/List.vue') },
      { path: '/tareas/form', component: () => import('pages/admin/tareas/Form.vue') },
      { path: '/tareas/form/:id', component: () => import('pages/admin/tareas/Form.vue') },
      { path: '/tareas/view/:id', component: () => import('pages/admin/tareas/View.vue') },
      { path: '/tareas_tecnico/view/:id', component: () => import('pages/tecnico/View.vue') },
      { path: '/gestion_tareas', component: () => import('pages/tecnico/GestionTareas.vue') },
      { path: '/gestion_tareas/factura/:id', component: () => import('pages/tecnico/Form.vue') },
      { path: '/historial_equipos', component: () => import('pages/tecnico/HistorialEquipos.vue') },
      { path: '/historial_equipos_cliente', component: () => import('pages/cliente/HistorialEquipos.vue') },
      { path: '/historial_equipos_cliente/view/:id', component: () => import('pages/cliente/HistorialEquiposView.vue') },
      { path: '/historial_Tareas_cliente', component: () => import('pages/cliente/HistorialTareas.vue') },
      { path: '/historial_Tareas_cliente/view/:id', component: () => import('pages/cliente/HistorialTareasView.vue') },
      { path: '/alarmas', component: () => import('pages/cliente/alarmas/List.vue') },
      { path: '/alarmas/form', component: () => import('pages/cliente/alarmas/Form.vue') },
      { path: '/alarmas/form/:id', component: () => import('pages/cliente/alarmas/Form.vue') },
      { path: '/alarmas/view/:id', component: () => import('pages/cliente/alarmas/View.vue') },
      { path: '/notificaciones_cliente', component: () => import('pages/cliente/notificaciones/List.vue') },
      //{ path: '/notificaciones_cliente/view/:id', component: () => import('pages/cliente/notificaciones/View.vue') },
      { path: '/notificaciones', component: () => import('pages/admin/notificaciones/List.vue') },
      { path: '/notificaciones/form', component: () => import('pages/admin/notificaciones/Form.vue') },
      { path: '/notificaciones/form/:id', component: () => import('pages/admin/notificaciones/Form.vue') },
      { path: '/notificaciones/view/:id', component: () => import('pages/admin/notificaciones/View.vue') },
      { path: '/bitacora', component: () => import('pages/admin/bitacora/List.vue') },
      { path: '/bitacora/form', component: () => import('pages/admin/bitacora/Form.vue') },
      { path: '/bitacora/form/:id', component: () => import('pages/admin/bitacora/Form.vue') },
      { path: '/bitacora/view/:id', component: () => import('pages/admin/bitacora/View.vue') },
      { path: '/alarmas_clientes', component: () => import('pages/admin/alarmas/List.vue') },
      { path: '/alarmas_clientes/view/:id', component: () => import('pages/admin/alarmas/View.vue') },
      { path: '/alarmas_usuarios', component: () => import('pages/usuario/alarmas/List.vue') },
      { path: '/alarmas_usuarios/form', component: () => import('pages/usuario/alarmas/Form.vue') },
      { path: '/creacion_usuarios', component: () => import('pages/cliente/users/List.vue') },
      { path: '/creacion_usuarios/form', component: () => import('pages/cliente/users/Form.vue') },
      { path: '/creacion_usuarios/form/:id', component: () => import('pages/cliente/users/Form.vue') },
      { path: '/clientes', component: () => import('pages/admin/clientes/List.vue') },
      { path: '/clientes/form', component: () => import('pages/admin/clientes/Form.vue') },
      { path: '/clientes/form/:id', component: () => import('pages/admin/clientes/Form.vue') },
      { path: '/clientes/view/:id', component: () => import('pages/admin/clientes/View.vue') },
      { path: '/clientes/equipos/:id', component: () => import('pages/admin/clientes/Equipos.vue') },
    ]
  },
  {
    path: '/login',
    component: () => import('pages/Login.vue'),
  },
  {
    path: '/',
    redirect: '/login'
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
